import { deDE, enUS } from "@mui/x-data-grid-pro";
export const tableLangs : {[char: string]: any} = { en: enUS.components.MuiDataGrid.defaultProps.localeText, de: deDE.components.MuiDataGrid.defaultProps.localeText };
export const defaultAppLang = 'de';
export const INITIAL_FIELD_STATE = { value: '', dirty: false, error: false };
export const API_URL = "http://172.16.64.128:2070/";
export const AUTH = "vOv8Rpe50vm1iAAiW886QEdvN3JWFF3AOUZly89Y";